const NAMESPACE = "testConnectionMultiInstanceRequestField";

const KEYS = {
    addElementButtonLabel: "addElementButtonLabel",
    removeElementButtonLabel: "removeElementButtonLabel"
};

const MESSAGES = {
    [KEYS.addElementButtonLabel]: {
        value: "Add Element",
        comment: "Button label for adding a new request field element"
    },
    [KEYS.removeElementButtonLabel]: {
        value: "Remove Element",
        comment: "Button label for removing a request field element"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
